import NumberOfInsights from "./NumberOfInsights";

export default NumberOfInsights;
